import { ValidationError } from "sequelize"
import {
    OkrObjectiveComment,
    OkrObjectiveCommentCreate,
    OkrObjectiveCommentSave,
    OkrObjectiveCommentAttachment,
    SaveOkrObjectiveCommentAttachmentType,
    MtDriveFile,
} from "server/models"
import { GET, POST, DELETE, validate } from "client/store/utils"
import { LangType } from "client/store"
import { OkrObjectiveCommentValidation } from "./types"


export const LoadAllOkrObjectiveComments = (objectiveId: number) => (
    GET(`/okrObjectiveComment/objectiveId/${objectiveId}`)
    .then((comments: OkrObjectiveComment[]) => comments)
)

export const LoadOkrObjectiveCommentById = (commentId: number) => (
    GET(`/okrObjectiveComment/id/${commentId}`)
    .then((comment: OkrObjectiveComment) => comment)
)

export const SaveOkrObjectiveComment = (
    id: number,
    comment: OkrObjectiveCommentCreate,
    attachments: readonly MtDriveFile[],
    lang: LangType,
) => {
    const data: OkrObjectiveCommentSave = {
        id,
        comment,
    }
    return POST(
        "/okrObjectiveComment/save",
        JSON.stringify(data),
    ).then((res) => {
        const newComment = res as OkrObjectiveComment
        const error = res as ValidationError

        const newCommentId = newComment.id || null
        const validation = <OkrObjectiveCommentValidation>validate(error, lang)

        if (validation) {
            return {
                newCommentId,
                validation,
            }
        }

        const attachmentData: OkrObjectiveCommentAttachment[] = []
        attachments.forEach((file, index) => {
            attachmentData.push({
                commentId: newCommentId || id,
                fileId: file.id,
                order: index,
            })
        })

        return SaveOkrObjectiveCommentAttachments(newCommentId || id, attachmentData)
        .then(() => ({
            newCommentId,
            validation,
        }))
    })
}

export const DeleteOkrObjectiveComment = (
    commentId: number,
    objectiveId: number,
) => (
    DELETE(`/okrObjectiveComment/delete/${commentId}/${objectiveId}`)
    .then((removedRows: number) => removedRows)
)

export const LoadOkrObjectiveCommentAttachments = (commentId: number) => (
    GET(`/okrObjectiveCommentAttachment/commentId/${commentId}`)
    .then((attachments: OkrObjectiveCommentAttachment[]) => attachments)
)

export const SaveOkrObjectiveCommentAttachments = (
    commentId: number,
    attachments: OkrObjectiveCommentAttachment[],
) => {
    const attachmentsData: SaveOkrObjectiveCommentAttachmentType = {
        commentId,
        attachments,
    }
    return POST(
        "/okrObjectiveCommentAttachment/save",
        JSON.stringify(attachmentsData),
    )
}
